var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "link-list", class: [_vm.bemFacets] }, [
    _c(
      "ul",
      { staticClass: "link-list--collection u-reset" },
      _vm._l(_vm.links, function(link, index) {
        return _c(
          "li",
          { key: index, staticClass: "link-list--item" },
          [
            _c(
              "conditional-link",
              _vm._b(
                { staticClass: "link-list--link u-reset" },
                "conditional-link",
                link,
                false
              ),
              [
                _vm._v(
                  "\n                " +
                    _vm._s(link.label) +
                    "\n                "
                ),
                _c("base-icon", {
                  staticClass: "link-list--icon",
                  attrs: {
                    size: "medium",
                    symbol: _vm.getIconByType(link.type)
                  }
                })
              ],
              1
            )
          ],
          1
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25bf7008", { render: render, staticRenderFns: staticRenderFns })
  }
}